import { render, staticRenderFns } from "./WebPushNotificationPermission.vue?vue&type=template&id=72c8f7e1&"
import script from "./WebPushNotificationPermission.vue?vue&type=script&lang=js&"
export * from "./WebPushNotificationPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports